<!-- Global system message ribbon -->
<app-system-message></app-system-message>

<div [ngClass]="theme.getThemeClass()" class="container-fluido invoice-generation">
  <div [ngClass]="theme.getThemeClass()" class="card bg-light">
    <article class="card-body mx-auto article">
      <!-- Page title with filter toggle -->
      <div class="invoice-header">
        <h4 class="card-title mt-0 text-center">
          {{ 'invoiceGeneration.title' | translate }}
        </h4>
        <button class="btn btn-filter-toggle" (click)="toggleFilters()">
          <i class="fa-solid fa-filter"></i>
        </button>
      </div>

      <!-- Filter form (client, devices, invoice type) -->
      <div class="form-grid" [class.is-hidden]="!showFilters">
        <div class="form-group">
          <label class="form-label">{{ 'invoiceGeneration.client' | translate }}</label>
          <select
            class="form-control"
            [(ngModel)]="selectedClient"
            (change)="onClientChange()"
          >
            <option [ngValue]="''">{{ 'invoiceGeneration.selectClient' | translate }}</option>
            @for (client of clients; track client.client_id) {
              <option [ngValue]="client.client_id">
                {{ client.legal_name || client.client_name || client.client_id }}
              </option>
            }
          </select>
        </div>

        <div class="form-group">
          <!-- Device multiselect -->
          <div class="label-row">
            <label class="form-label">
              {{ 'invoiceGeneration.devices' | translate }}
              <span class="count">({{ deviceOptions.length }})</span>
            </label>
            <div class="select-links">
              <button
                class="btn-link select-all-link"
                type="button"
                (click)="selectAllDevices()"
              >
                {{ 'selectALl' | translate }}
              </button>
              <button
                class="btn-link select-all-link"
                type="button"
                (click)="clearSelectedDevices()"
              >
                {{ 'clear' | translate }}
              </button>
            </div>
          </div>
          <div class="multi-select-wrapper">
            <app-custom-multi-select
              [(ngModel)]="selectedDevices"
              class="form-control ng-select"
              [multiple]="true"
              [options]="deviceOptions"
              bindLabel="id"
              bindValue="id"
            ></app-custom-multi-select>
            @if (loadingDevices) {
              <div class="loading-inline">{{ 'loading' | translate }}</div>
            }
          </div>
        </div>

        <div class="form-group">
          <!-- Invoice type selector -->
          <label class="form-label">{{ 'invoiceGeneration.type' | translate }}</label>
          <select class="form-control" [(ngModel)]="invoiceType">
            <option [ngValue]="''">{{ 'invoiceGeneration.selectType' | translate }}</option>
            <option [ngValue]="'subscription'">{{ 'invoiceGeneration.subscription' | translate }}</option>
            <option [ngValue]="'installation'">{{ 'invoiceGeneration.installation' | translate }}</option>
          </select>
        </div>
      </div>

      <!-- Prepare action -->
      <div class="actions" [class.is-hidden]="!showFilters">
        <button
          class="btn btn-dropdown fixed-size"
          [disabled]="!canProceed()"
          (click)="goNext()"
        >
          {{ 'invoiceGeneration.prepare' | translate }}
        </button>
      </div>
    </article>
  </div>

  <div class="child-wrapper" [class.child-hidden]="showFilters">
    <router-outlet></router-outlet>
  </div>
</div>
